import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { useNavigate } from 'react-router-dom'

const ProyectoCardItem = ({ item, handleOnClick }) => {
  const tooltipText = `${item?.code} - ${item?.name}`
  const { user } = useAuth0()
  const isAdminMongo = item?.user?.includes(user.sub)
  const navigate = useNavigate()

  const showTooltip = item?.name?.length > 13 || item?.code?.length > 5

  return (
    <figure
      className={`project-item project-item--admin ${showTooltip ? 'tooltip' : ''}`}
      key={item?.code}
      data-tooltip={showTooltip ? tooltipText : ''}
      onClick={() => handleOnClick(item._id)}
    >
      <img
        alt="Proyecto"
        src={
          item.image ||
          'https://jit.fra1.digitaloceanspaces.com/Test_building.jpg'
        }
      />
      <div className="project-body project-body--admin">
        <div className="project-body-icons">
          <p>{item?.code}</p>
        </div>
        <div className="project-body-name project-body-name--admin">
          <p>{item?.name}</p>
        </div>

        {isAdminMongo && (
          <button
            className="btn-editar-proyecto"
            onClick={e => {
              e.stopPropagation()
              navigate(`/proyectos/${item._id}/config`)
            }}
          >
            <EditOutlinedIcon fontSize="small" />
          </button>
        )}
      </div>
    </figure>
  )
}

export default ProyectoCardItem
